// extracted by mini-css-extract-plugin
module.exports = {"container":"Skills_container__2Ad2B","skill":"Skills_skill__1uscR","skillContainer":"Skills_skillContainer__1V1jx","text":"Skills_text__2LDcJ"};